export enum DiscType {
  D = 'D',
  I = 'I',
  S = 'S',
  C = 'C'
}
